import React from 'react';
import type { AuditLog } from '../../../models/auditLog';
import { formatUtcDateTime } from '../../../shared/utils/formatDate';

export interface AuditLogTableProps {
  rows: AuditLog[];
  onView: (row: AuditLog) => void;
}

export function AuditLogTable({ rows, onView }: AuditLogTableProps): React.ReactElement {
  return (
    <div className="bo-card">
      <div className="bo-admin-table-wrap">
        <table className="bo-admin-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Target</th>
              <th aria-label="Actions" />
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>{formatUtcDateTime(row.createdAt)}</td>
                <td>{row.actorEmail || '—'}</td>
                <td>{row.actionType}</td>
                <td>
                  {row.targetType
                    ? `${row.targetType}${
                        row.targetName ? ` (${row.targetName})` : row.targetId ? ` (${row.targetId})` : ''
                      }`
                    : '—'}
                </td>
                <td>
                  <div className="bo-actions">
                    <button type="button" className="bo-btn bo-btn-secondary" onClick={() => onView(row)}>
                      View
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
